import React from 'react'
import MarketingRow from './MarketingRow'

export default function MarketingRowCentered(props) {
    return <MarketingRow center={true} {...props} />
}
